import { render, staticRenderFns } from "./pageDevice.vue?vue&type=template&id=6829bc60&scoped=true"
import script from "./pageDevice.vue?vue&type=script&lang=js"
export * from "./pageDevice.vue?vue&type=script&lang=js"
import style0 from "./pageDevice.vue?vue&type=style&index=0&id=6829bc60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6829bc60",
  null
  
)

export default component.exports